
document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("change", function (event) {
        if (event.target.classList.contains("quantity__input")) {
            let input = event.target;
            let variantId = input.getAttribute("data-quantity-variant-id");
            let newQty = parseInt(input.value) || 1;

            updateShopifyCart(variantId, newQty);
        }
    });
    // ✅ Event Listener to Remove Cart Item
    document.body.addEventListener("click", function (event) {
        let removeButton = event.target.closest("cart-remove-button a");
        if (removeButton) {
            event.preventDefault();

            let rowElement = removeButton.closest("tr"); // Find the row to remove
            let variantId = removeButton.getAttribute("href").match(/id=([^&]+)/)[1]; // Extract variant ID

            removeCartItem(variantId, rowElement);
        }
    });
    updateCartCountOnLoad();
});
// ✅ Function to Update Shopify Cart via AJAX (Handles Quantity Changes)
function updateShopifyCart(variantId, newQty) {
    fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: newQty })
    })
    .then(response => response.json())
    .then(cart => {
        updateCartPrices(cart);
        updateCartTotal(cart);
        updateCartCount(cart);
    })
    .catch(error => console.error("Error updating cart:", error));
}
// ✅ Function to Remove Cart Item & Update UI
function removeCartItem(variantId, rowElement) {
    fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 0 })
    })
    .then(response => response.json())
    .then(cart => {
        if (rowElement) {
            rowElement.remove(); // ✅ Remove row from cart table
        }
        updateCartTotal(cart); // ✅ Ensure total updates correctly
        updateCartCount(cart);
    })
    .catch(error => console.error("Error removing item:", error));
}
// ✅ Function to Format Money
function formatMoney(cents) {
    let currencySymbol = "$"; // Adjust currency based on store settings
    let amount = (cents / 100).toFixed(2);
    return currencySymbol + amount;
}
// ✅ Function to Update Cart Prices Dynamically
function updateCartPrices(cart) {
    cart.items.forEach(item => {
        let itemPriceElement = document.querySelector(`[data-variant-id="${item.variant_id}"] .price`);
        if (itemPriceElement) {
            itemPriceElement.innerText = formatMoney(item.final_line_price);
        }
    });
}
// ✅ Function to Update Total Price Dynamically
function updateCartTotal(cart) {
    fetch("/cart.js") // ✅ Fetch latest cart data from Shopify
        .then(response => response.json())
        .then(cartData => {
            let totalPriceElement = document.querySelector(".totals__total-value");
            if (totalPriceElement) {
                totalPriceElement.innerText = formatMoney(cartData.total_price);
            }
        })
        .catch(error => console.error("Error fetching total price:", error));
}
// ✅ Function to Update Cart Count (`.cart-count`)
function updateCartCount(cart) {
    fetch("/cart.js") // ✅ Fetch latest cart data from Shopify
        .then(response => response.json())
        .then(cartData => {
            let cartCountElement = document.querySelector(".cart-count");

            if (cartCountElement) {
                cartCountElement.innerText = cartData.item_count;
            }
        })
        .catch(error => console.error("Error fetching cart count:", error));
}
// ✅ Function to Ensure Cart Count Updates on Page Load
function updateCartCountOnLoad() {
    fetch("/cart.js")
        .then(response => response.json())
        .then(cartData => {
            let cartCountElement = document.querySelector(".cart-count");

            if (cartCountElement) {
                cartCountElement.innerText = cartData.item_count;
            }
        })
        .catch(error => console.error("Error loading cart count:", error));
}